import React from "react";
import { Flex, Rate } from "antd";

export default ({content = {}}) => {
    const {
        shopId,
        accId,
        title,
        logoUrl,
        shopType,
        status,
        contactPhoneNo,
        description,
        score,
    } = content;

    console.log('content', content);

    return (
        <Flex justify="" align="left" gap={10}>
            {/* <img style={{ width: 50, height: 50}} src="https://gw.alipayobjects.com/zos/rmsportal/KDpgvguMpGfqaHPjicRK.svg" alt="Ant Design" /> */}
            <div>
                <div>店铺名称：{title || '默认店铺'}</div>
                <div>店铺描述：{description}</div>
                <div>店铺评分：{score ? <Rate allowHalf defaultValue={score} /> : '暂无评分'}</div>
            </div>
        </Flex>
    )
}